var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-prolong-single"},[_c('base-prolong',{attrs:{"title":_vm.tariff.pricelist,"list":_vm.innerList},on:{"ready":_vm.onReady,"change":_vm.onChange,"change-total":_vm.onChangeTotal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }